<template>
  <div class="present">
    {{ $t('soucasnost') }}
  </div>
</template>

<script>
export default {
  name: 'Present',
};
</script>

<style lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/functions.scss';

.present {
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  background-color: $mediumWhite;
  color: white;
  border-radius: 6px;
  padding: 16px 32px;
  display: inline-block;
  position: relative;
  margin-bottom: 13px;

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 6.5px 0 6.5px;
    border-color: $mediumWhite transparent transparent transparent;
    position: absolute;
    bottom: -10px;
    left: calc(50% - 6.5px);
  }

  @include media-breakpoint-up(md) {
    font-size: 16px;
    line-height: 19px;
    padding: 22px 32px;
  }
}
</style>
